import { gql } from "@apollo/client";
import moment from "moment";

const GET_CAPA_DETALLE = gql`
query gestionCapaById ($idGestionCapa: Int!) {
    gestionCapaById(idGestionCapa: $idGestionCapa){
      idDelegacion  
      idDelegacionNavigation {
          idDelegacion
          descripcion
      }
      idArea
      idAreaNavigation {
        idAreaCapa
        descripcion
      }
      fechaApertura
      idFuente
      idFuenteNavigation {
        idFuenteCapa
        descripcion
      }
      idResponsableAccion
      idResponsableAccionNavigation {
        nombre
        apellido
      }
      idUsuarioCreador
      idUsuarioCreadorNavigation {
        nombre
        apellido
      }
      idEstado
      idEstadoNavigation {
        idEstadoReclamo
        descripcion
      }
      idEtapa
      idEtapaNavigation {
        idEtapaCapa
        descripcion
      }
      idGestionReclamoNavigation {
        idGestionReclamo
        descripcion
      }
      prorrogaCapa{
        fechaProrroga
        fechaAlta
        justificacion
        idUsuarioAlta
        aprobada
      }
      idGestionReclamo
      idGestionCapa
      descripcion
      causa
      accion
      fechaAccion
      fechaCierre
      capaVencida
      observacion
      observacionFinal
      fechaCierreAccion
      prorrogaCapa{
        idProrrogaCapa
        idGestionCapa
        fechaProrroga
        justificacion
        idUsuarioAlta
        fechaAlta
      }
    }
}
`;
export default GET_CAPA_DETALLE;

export const adaptCapaCompleto = (capa) => {
  return {
    stage1: {
      fechaApertura: moment(capa?.fechaApertura).isValid() ? moment(capa?.fechaApertura).format("yyyy-MM-DD") : '',
      usuarioCreador: capa?.idUsuarioCreadorNavigation?.nombre + ' ' + capa?.idUsuarioCreadorNavigation?.apellido,
      idDelegacion: capa?.idDelegacion,
      fechaAccion: moment(capa?.fechaAccion).isValid() ? moment(capa?.fechaAccion).format("yyyy-MM-DD") : '',
      descripcion: capa?.descripcion,
      idArea: capa?.idArea,
      idFuente: capa?.idFuente,
      idGestionReclamo: capa?.idGestionReclamo,
      accion: capa?.accion,
      causa: capa?.causa,
      observacion: capa?.observacion,
      idResponsableAccion: capa?.idResponsableAccion
    },
    stage2: {
      fechaAccion: moment(capa?.fechaAccion).isValid() ? moment(capa?.fechaAccion).format("yyyy-MM-DD") : '',
      prorrogaCapa: capa?.prorrogaCapa,
      fechaCierreAccion: capa?.fechaCierreAccion
    },
    stage3: {
      fechaCierre: capa?.fechaCierre,
      observacionFinal: capa?.observacionFinal
    },
    stage4: {},
    stage5: {}
  };
};

export const adaptDelegacionCargadaCapa = (capa) => {
  return {
    id: capa?.idDelegacionNavigation?.idDelegacion,
    displayName: capa?.idDelegacionNavigation?.descripcion
  };
};